document.addEventListener('DOMContentLoaded', function() {
    const titles = document.querySelectorAll('.faq-title');
    if (titles) {
        titles.forEach(function(title, index) {
            title.addEventListener('click', function(e) {
                if (e.target.tagName === 'A') return;
                titles.forEach(function(otherTitle) {
                    if (otherTitle !== title) {
                        otherTitle.classList.remove('active');
                        const otherContent = otherTitle.nextElementSibling;
                        if (otherContent) {
                            otherContent.classList.remove('show');
                        }
                    }
            });
                this.classList.toggle('active');
                const content = this.nextElementSibling;
                if (content) {
                    content.classList.toggle('show');
                }
            });
        });
    }
});